<template>
  <div class="grid grid-cols-4 gap-4">
    <div>
      <base-label>Photographer</base-label>
      <el-select v-model="photographerId" placeholder="Select" class="w-full">
        <el-option
          v-for="photographer in photographers"
          :key="photographer.id"
          :label="photographer.name"
          :value="photographer.id"
        >
        </el-option>
      </el-select>
    </div>
    <div>
      <base-label>Start Date</base-label>
      <el-date-picker
        v-model="startDate"
        type="date"
        placeholder="Select a date"
        format="MM/dd/yyyy"
        value-format="yyyy-MM-dd"
      >
      </el-date-picker>
    </div>

    <div>
      <base-label>End Date</base-label>
      <el-date-picker
        v-model="endDate"
        type="date"
        placeholder="Select a date"
        class="w-full"
        format="MM/dd/yyyy"
        value-format="yyyy-MM-dd"
      >
      </el-date-picker>
    </div>
    <div>
      <base-button-primary class="mt-5" @click="handleSearch"
        >Search</base-button-primary
      >
      <base-button-primary class="mt-5 ml-5" @click="handleExport"
        >Export</base-button-primary
      >
    </div>
    <div class="col-span-4 text-sm">
      <vue-good-table
        :columns="columns"
        :rows="orders"
        :search-options="{ enabled: true }"
        :sort-options="{
          enabled: true,
          initialSortBy: { field: 'id', type: 'asc' },
        }"
        :fixed-header="true"
        max-height="800px"
        :pagination-options="{
          enabled: true,
          mode: 'records',
          perPage: 50,
          position: 'bottom',
          perPageDropdown: [25, 50, 100],
          dropdownAllowAll: false,

          nextLabel: 'next',
          prevLabel: 'prev',
          rowsPerPageLabel: 'Rows per page',
          ofLabel: 'of',
        }"
      >
        <template slot="table-row" slot-scope="props">
          <span v-if="props.column.label == 'Base Price'">
            ${{
              (
                props.row.subtotal / 100 +
                props.row.discount_value / 100 +
                props.row.discount24 / 100
              ).toFixed(2)
            }}
          </span>
          <span v-else-if="props.column.label == 'Subtotal'">
            ${{ (props.row.subtotal / 100).toFixed(2) }}
          </span>

          <span v-else-if="props.column.field == 'isTwentyFourHour'">
            {{ props.row.isTwentyFourHour ? "Yes" : "No" }}
          </span>
          <span v-else>
            {{ props.formattedRow[props.column.field] }}
          </span>
        </template>
      </vue-good-table>
    </div>
  </div>
</template>

<script>
import "vue-good-table/dist/vue-good-table.css";
import { VueGoodTable } from "vue-good-table";
import BaseButtonPrimary from "@/components/ui/buttons/BaseButtonPrimary";

export default {
  name: "Photographer",
  components: {
    BaseButtonPrimary,
    VueGoodTable,
  },

  props: {},
  data() {
    return {
      photographerId: null,
      orders: [],
      columns: [
        {
          label: "ID",
          field: "id",
          type: "number",
        },
        {
          label: "Date",
          field: "display_date",
        },
        {
          label: "Twenty Four Hour",
          field: "isTwentyFourHour",
        },
        {
          label: "Outfitter",
          field: "name",
        },
        {
          label: "Base Price",
          field: "subtotal",
          type: "decimal",
        },

        {
          label: "Subtotal",
          field: "subtotal",
          type: "decimal",
        },
      ],
    };
  },
  methods: {
    handleExport() {
      if (!this.photographerId) {
        this.$notify({
          title: "Search",
          message: "Please select a photographer",
          type: "warning",
        });
        return;
      }
      let url = process.env.VUE_APP_BASE_URL + "/order/export-for-photographer";
      url += "?photographerId=" + this.photographerId;
      url += this.startDate ? "&startDate=" + this.startDate : "";
      url += this.endDate ? "&endDate=" + this.endDate : "";
      url = encodeURI(url);
      window.open(url, "_blank");
    },
    handleSearch() {
      if (!this.photographerId) {
        this.$notify({
          title: "Search",
          message: "Please select a photographer",
          type: "warning",
        });
        return;
      }
      this.$notify({
        title: "Search",
        message: "Fetching data...",
        type: "success",
      });
      const data = {
        startDate: this.startDate,
        endDate: this.endDate,
        photographerId: this.photographerId,
      };
      this.$store.dispatch("order/forPhotographer", data).then((resp) => {
        this.orders = Object.values(resp.orders);
        if (!this.orders.length) {
          this.$notify({
            title: "Order",
            message: "No orders found",
            type: "warning",
          });
        }
      });
    },
  },
  computed: {
    photographers: function () {
      return this.$store.getters["photographer/getPhotographers"];
    },
    startDate: {
      get() {
        return this.$store.getters["report/getStartDate"];
      },
      set(value) {
        this.$store.dispatch("report/set_start_date", value);
      },
    },
    endDate: {
      get() {
        return this.$store.getters["report/getEndDate"];
      },
      set(value) {
        this.$store.dispatch("report/set_end_date", value);
      },
    },
  },
  watch: {},
  mounted() {
    this.$store.dispatch("photographer/all");
  },
};
</script>

<style scoped>
>>> table.vgt-table td {
  padding: 0.25em;
  font-size: 14px;
}
>>> .vgt-table th.sortable button {
  font-size: 14px;
}
</style>
